const Terms = () => {
  return (
    <>
      <h1
        style={{
          fontSize: "32px",
          lineHeight: "32px",
          marginBottom: "24px",
          marginTop: "24px",
          color: "#fff",
          backgroundClip: "unset",
          animation: "none",
          WebkitBackgroundClip: "unset",
          WebkitTextFillColor: "unset",
          background: "transparent",
          fontWeight: 700,
        }}
      >
        Terms and Conditions for DecoHouse
      </h1>

      <p>
        <strong>Effective Date:</strong> 10 October, 2025
        <br />
        <strong>Last Updated:</strong> 10 October, 2025
      </p>

      <p>
        <strong>DecoHouse</strong> ("we", "us", or "our") is developed and
        operated by <strong>MB Kozidev</strong>. By accessing or using the
        DecoHouse mobile app (the "App"), you agree to be bound by these Terms
        and Conditions ("Terms"). If you do not agree to these Terms, do not use
        the App.
      </p>

      <h2>1. User Eligibility</h2>
      <p>
        You must be at least <strong>16 years old</strong> to use the App. By
        using the App, you confirm that you meet the minimum age requirement and
        have the legal capacity to accept these Terms.
      </p>

      <h2>2. Account Terms</h2>
      <ul>
        <li>
          Users are responsible for maintaining the{" "}
          <strong>security of their accounts</strong>, including their email and
          password.
        </li>
        <li>
          After the account is initially created without an email address, it is
          the user’s responsibility to complete registration to avoid losing
          access.
        </li>
        <li>
          Users may only create <strong>one account</strong>. Multiple accounts
          are prohibited.
        </li>
        <li>
          Accounts inactive for <strong>12 months</strong> (no image generation
          or credit purchases) will be deleted.
        </li>
        <li>
          You are responsible for all activity that occurs under your account.
        </li>
      </ul>

      <h2>3. Purchases and Credits</h2>
      <ul>
        <li>
          DecoHouse uses an in-app currency called <strong>Credits</strong>.
          Some credits may be provided for free upon account creation.
          Additional credits can be purchased through{" "}
          <strong>Google Play</strong> or <strong>Apple App Store</strong>{" "}
          in-app purchase mechanisms.
        </li>
        <li>Credits may be bundled, discounted, or part of promotions.</li>
        <li>
          <strong>Refunds</strong> are governed by Google Play / Apple App Store
          policies, except when we determine an image does not meet quality
          standards — in which case credits may be refunded at our discretion.
        </li>
        <li>
          <strong>1 credit</strong> = 1 AI image generation.
        </li>
        <li>
          Credits are <strong>non-transferable</strong> and{" "}
          <strong>expire 12 months</strong> after purchase.
        </li>
      </ul>

      <h2>4. User Content</h2>
      <ul>
        <li>
          Users own the <strong>images they generate</strong> within the App.
        </li>
        <li>
          Users are solely responsible for ensuring that uploaded reference
          images or generated content do not infringe copyright, violate laws,
          contain offensive content, or violate these Terms.
        </li>
        <li>
          Users must only generate content related to{" "}
          <strong>house interior, exterior, or garden design</strong>.
        </li>
        <li>
          DecoHouse is <strong>not responsible</strong> for any images generated
          outside these purposes.
        </li>
        <li>
          Users must <strong>save generated images to their device</strong>, as
          we do <strong>not store generated images</strong> on our servers.
          DecoHouse is not responsible for any loss of generated images.
        </li>
        <li>
          Users grant DecoHouse a{" "}
          <strong>limited license to process images</strong> solely for
          providing the App’s functionality.
        </li>
      </ul>

      <p>We disclaim any liability for:</p>
      <ul>
        <li>Financial loss or damages resulting from generated images</li>
        <li>
          Errors, inaccuracies, or unrealistic representations in AI-generated
          content
        </li>
        <li>Any user misuse of AI-generated content</li>
      </ul>

      <h2>5. Prohibited Uses</h2>
      <p>You may not:</p>
      <ul>
        <li>
          Reverse engineer, decompile, or attempt to extract source code from
          the App
        </li>
        <li>Misuse AI-generated outputs</li>
        <li>
          Attempt to disrupt, overload, or interfere with the App or its servers
        </li>
        <li>Use the App for illegal, offensive, or unauthorized purposes</li>
        <li>Impersonate another user or entity</li>
      </ul>

      <h2>6. Disclaimers / Limitations of Liability</h2>
      <ul>
        <li>
          The App and AI-generated images are provided <strong>"as-is"</strong>{" "}
          without warranties of any kind.
        </li>
        <li>
          Generated images may{" "}
          <strong>not accurately represent real-life results</strong> and are
          for <strong>inspiration only</strong>.
        </li>
        <li>
          DecoHouse is not liable for{" "}
          <strong>financial losses, damages, or consequences</strong> arising
          from your use of generated content.
        </li>
      </ul>

      <h2>7. Third-Party Services</h2>
      <p>
        The App uses third-party services including <strong>Sashido</strong>,{" "}
        <strong>AppsFlyer</strong>, <strong>Google Services</strong>, and{" "}
        <strong>Sentry</strong>. Use of these services is governed by their
        respective privacy policies. DecoHouse is not responsible for
        third-party actions.
      </p>

      <h2>8. Governing Law and Dispute Resolution</h2>
      <ul>
        <li>
          These Terms are governed by the laws of <strong>Lithuania</strong>.
        </li>
        <li>
          Any disputes arising from these Terms shall be resolved by the{" "}
          <strong>courts of Lithuania</strong>, unless otherwise required by
          mandatory law.
        </li>
      </ul>

      <h2>9. Termination / Suspension</h2>
      <ul>
        <li>
          DecoHouse may suspend or terminate accounts for violations of these
          Terms or unfair use.
        </li>
        <li>
          Upon termination, user data will be retained for{" "}
          <strong>12 months</strong> or as required by law.
        </li>
      </ul>

      <h2>10. Updates to Terms</h2>
      <ul>
        <li>DecoHouse may update these Terms from time to time.</li>
        <li>
          Updated Terms will be accessible in the <strong>Settings</strong>{" "}
          section of the App.
        </li>
        <li>
          Continued use of the App constitutes acceptance of the updated Terms.
        </li>
      </ul>

      <h2>11. Contact</h2>
      <p>
        For questions or concerns regarding these Terms, please contact:
        <br />
        <strong>Email:</strong>{" "}
        <a href="mailto:support@kozidevtech.com">support@kozidevtech.com</a>
      </p>

      <h2>12. Liability Reduction and Indemnity</h2>

      <h3>Limitation of Liability</h3>
      <p>To the fullest extent permitted by law:</p>
      <ul>
        <li>
          DecoHouse, MB Kozidev, and its affiliates, officers, employees, or
          agents shall <strong>not be liable</strong> for any direct, indirect,
          incidental, consequential, special, or punitive damages arising out of
          or in connection with:
        </li>
        <ul>
          <li>The use or inability to use the App</li>
          <li>
            AI-generated images, including inaccuracies, unrealistic
            representations, or financial loss
          </li>
          <li>Loss of user-generated or saved content</li>
          <li>
            Any reliance on generated images for design, financial, or personal
            decisions
          </li>
          <li>Use of third-party services integrated with the App</li>
        </ul>
      </ul>

      <h3>Indemnification</h3>
      <p>
        You agree to <strong>indemnify, defend, and hold harmless</strong>{" "}
        DecoHouse, MB Kozidev, and its affiliates from and against any claims,
        damages, losses, liabilities, costs, and expenses (including reasonable
        legal fees) arising from:
      </p>
      <ul>
        <li>Your violation of these Terms</li>
        <li>
          Your use of the App in a manner not intended or authorized by these
          Terms
        </li>
        <li>
          Your upload of content that violates copyright, law, or third-party
          rights
        </li>
        <li>Any actions taken by you based on AI-generated images</li>
      </ul>

      <h3>No Guarantee of Results</h3>
      <ul>
        <li>
          AI-generated images are <strong>for inspiration only</strong> and are
          not guaranteed to be accurate, realistic, or usable for real-world
          projects.
        </li>
        <li>
          Users are solely responsible for verifying any ideas, designs, or
          modifications before implementation.
        </li>
      </ul>

      <h3>User Responsibility</h3>
      <ul>
        <li>
          Users are solely responsible for storing and backing up generated
          images. DecoHouse <strong>does not store images</strong> on servers.
        </li>
        <li>
          Users are responsible for ensuring uploaded content is legal,
          non-offensive, and within the permitted scope (house interior,
          exterior, and garden design).
        </li>
      </ul>
    </>
  );
};

export default Terms;
